
export default function About() {
  return (
    <section id="about" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* CEO Message */}
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center mb-16 md:mb-24">
          {/* Left - Logo & CEO */}
          <div className="space-y-6 md:space-y-8">
            <div className="flex items-center gap-3 md:gap-4">
              <img
                src="https://static.readdy.ai/image/2299103fa86076f2ed06076e2d6cbff8/b0216ecd9824ced9791064a8a701a53c.png"
                alt="ROBO Asset Grid Logo"
                className="h-12 md:h-16 w-auto"
              />
              <div>
                <p className="text-sm md:text-base text-gray-500 font-semibold">About</p>
                <h2 className="text-2xl md:text-4xl font-black text-gray-900">
                  ROBO Asset Grid
                </h2>
              </div>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-white rounded-2xl p-5 md:p-8 border border-teal-100">
              <p className="text-sm md:text-lg text-gray-700 leading-relaxed mb-4 font-medium">
                Hello,<br />
                I am Lee Dong-Woo, CEO of ROBO Asset Grid Co., Ltd.
              </p>
              <p className="text-sm md:text-lg text-gray-700 leading-relaxed mb-4 font-medium">
                Our company was established with the <strong className="text-teal-700">3C core vision</strong> of Carbon-free, Connected, and Consumer, specializing in the manufacturing, production, and distribution of smart water meters.
              </p>
              <p className="text-sm md:text-lg text-gray-700 leading-relaxed mb-4 font-medium">
                Through our &lsquo;Smart Optical Sensor Water Meter&rsquo;, households, commercial buildings, and offices will be able to significantly reduce water bills. Connected with IoT (Internet of Things), it enables the collection, processing, and exchange of energy data.
              </p>
              <p className="text-sm md:text-lg text-gray-700 leading-relaxed mb-6 font-medium">
                This information is stored in cloud systems and utilized for &ldquo;Energy Saving&rdquo; to protect the environment, realize a carbon-zero society, and provide stable basic infrastructure to underdeveloped countries and regions lacking utility (gas, electricity, water) infrastructure.
              </p>
              <div className="flex items-center gap-4 pt-4 border-t border-teal-200">
                <div>
                  <p className="text-base md:text-xl font-bold text-gray-900 italic">
                    Lee Dong-Woo
                  </p>
                  <p className="text-xs md:text-base text-gray-500 font-medium">CEO, ROBO Asset Grid</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Product Showcase */}
          <div className="space-y-6 md:space-y-8">
            <div className="relative bg-gradient-to-br from-[#0a3d4f] to-[#0a2e3d] rounded-2xl md:rounded-3xl p-4 sm:p-6 md:p-10 overflow-hidden">
              <div className="absolute top-0 right-0 w-40 h-40 bg-teal-400/10 rounded-full blur-[60px]"></div>
              <div className="relative w-full h-[220px] sm:h-[300px] md:h-[400px] flex items-center justify-center">
                <img
                  src="https://static.readdy.ai/image/2299103fa86076f2ed06076e2d6cbff8/3bb60e1413457df40dbc6ee39e0447f8.png"
                  alt="Optical Sensor Smart Digital Water Meter"
                  title="ROBO Asset Grid Optical Sensing Smart Digital Water Meter Product"
                  className="w-full h-full object-contain drop-shadow-2xl"
                />
              </div>
              <div className="mt-4 md:mt-6 grid grid-cols-3 gap-3 md:gap-4">
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 text-center">
                  <div className="text-xl md:text-2xl font-black text-teal-400">
                    3C
                  </div>
                  <div className="text-[10px] md:text-xs text-white/70 mt-1">
                    Core Vision
                  </div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 text-center">
                  <div className="text-xl md:text-2xl font-black text-teal-400">
                    IoT
                  </div>
                  <div className="text-[10px] md:text-xs text-white/70 mt-1">
                    Real-time Sync
                  </div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 text-center">
                  <div className="text-xl md:text-2xl font-black text-teal-400">
                    0%
                  </div>
                  <div className="text-[10px] md:text-xs text-white/70 mt-1">
                    Lead Content
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Business Composition */}
        <div className="bg-gradient-to-br from-gray-50 to-teal-50/30 rounded-2xl p-5 md:p-8 lg:p-12">
          <div className="text-center mb-8 md:mb-12">
            <div className="inline-block px-4 py-2 bg-teal-50 rounded-full mb-4">
              <span className="text-teal-600 text-base font-bold">
                Business Composition
              </span>
            </div>
            <h3 className="text-2xl md:text-4xl font-black text-gray-900">
              Business Structure Plan
            </h3>
          </div>

          {/* Diagram Grid */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            <div className="bg-white rounded-xl p-4 md:p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-10 md:w-14 h-10 md:h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-3 md:mb-4">
                <i className="ri-settings-3-line text-xl md:text-2xl text-teal-600"></i>
              </div>
              <h4 className="text-sm md:text-xl font-bold text-gray-900 mb-1 md:mb-2">
                Automation
              </h4>
              <p className="text-xs md:text-base text-gray-600 font-medium">
                Automated water metering and management system
              </p>
            </div>

            <div className="bg-white rounded-xl p-4 md:p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-10 md:w-14 h-10 md:h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-3 md:mb-4">
                <i className="ri-fire-line text-xl md:text-2xl text-teal-600"></i>
              </div>
              <h4 className="text-sm md:text-xl font-bold text-gray-900 mb-1 md:mb-2">
                Optical Gas Meter
              </h4>
              <p className="text-xs md:text-base text-gray-600 font-medium">
                Integrated gas metering management solution
              </p>
            </div>

            <div className="bg-white rounded-xl p-4 md:p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-10 md:w-14 h-10 md:h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-3 md:mb-4">
                <i className="ri-wifi-line text-xl md:text-2xl text-teal-600"></i>
              </div>
              <h4 className="text-sm md:text-xl font-bold text-gray-900 mb-1 md:mb-2">
                IoT Integration
              </h4>
              <p className="text-xs md:text-base text-gray-600 font-medium">
                Real-time monitoring based on IoT
              </p>
            </div>

            <div className="bg-white rounded-xl p-4 md:p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-10 md:w-14 h-10 md:h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-3 md:mb-4">
                <i className="ri-dashboard-line text-xl md:text-2xl text-teal-600"></i>
              </div>
              <h4 className="text-sm md:text-xl font-bold text-gray-900 mb-1 md:mb-2">
                Digital Management
              </h4>
              <p className="text-xs md:text-base text-gray-600 font-medium">
                Cloud-based integrated management platform
              </p>
            </div>
          </div>

          {/* Flow Diagram */}
          <div className="mt-8 md:mt-12 flex flex-col md:flex-row items-center justify-center gap-3 md:gap-4">
            <div className="bg-teal-600 text-white px-4 md:px-6 py-2 md:py-3 rounded-lg font-bold text-base md:text-lg text-center whitespace-nowrap w-full md:w-auto">
              Smart Meter
            </div>
            <i className="ri-arrow-down-line md:hidden text-2xl text-teal-600"></i>
            <i className="ri-arrow-right-line text-2xl text-teal-600 hidden md:block"></i>
            <div className="bg-teal-600 text-white px-4 md:px-6 py-2 md:py-3 rounded-lg font-bold text-base md:text-lg text-center whitespace-nowrap w-full md:w-auto">
              IoT Data Collection
            </div>
            <i className="ri-arrow-down-line md:hidden text-2xl text-teal-600"></i>
            <i className="ri-arrow-right-line text-2xl text-teal-600 hidden md:block"></i>
            <div className="bg-teal-600 text-white px-4 md:px-6 py-2 md:py-3 rounded-lg font-bold text-base md:text-lg text-center whitespace-nowrap w-full md:w-auto">
              Cloud Analysis
            </div>
            <i className="ri-arrow-down-line md:hidden text-2xl text-teal-600"></i>
            <i className="ri-arrow-right-line text-2xl text-teal-600 hidden md:block"></i>
            <div className="bg-teal-600 text-white px-4 md:px-6 py-2 md:py-3 rounded-lg font-bold text-base md:text-lg text-center whitespace-nowrap w-full md:w-auto">
              Energy Saving
            </div>
          </div>
        </div>

        {/* Key Features */}
        <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <div className="text-center">
            <div className="w-14 md:w-16 h-14 md:h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
              <i className="ri-shield-check-line text-2xl md:text-3xl text-teal-600"></i>
            </div>
            <h4 className="text-lg md:text-2xl font-bold text-gray-900 mb-2">
              Safety
            </h4>
            <p className="text-sm md:text-lg text-gray-600 font-medium">
              Lead-free stainless steel material ensures safe water metering
            </p>
          </div>

          <div className="text-center">
            <div className="w-14 md:w-16 h-14 md:h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
              <i className="ri-line-chart-line text-2xl md:text-3xl text-teal-600"></i>
            </div>
            <h4 className="text-lg md:text-2xl font-bold text-gray-900 mb-2">
              Accuracy
            </h4>
            <p className="text-sm md:text-lg text-gray-600 font-medium">
              Optical sensing technology enables precise metering and fraud prevention
            </p>
          </div>

          <div className="text-center">
            <div className="w-14 md:w-16 h-14 md:h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
              <i className="ri-global-line text-2xl md:text-3xl text-teal-600"></i>
            </div>
            <h4 className="text-lg md:text-2xl font-bold text-gray-900 mb-2">
              Scalability
            </h4>
            <p className="text-sm md:text-lg text-gray-600 font-medium">
              Seamlessly integrates with smart city infrastructure through IoT
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
